import http from "../../http-common";

const getDashboard = async ({ start, end }) => {
  return await http
    .get("/admin/dashboard", { params: { start, end } })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

export default {
  getDashboard,
};
